'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _closure = require('./closure.html');

var _closure2 = _interopRequireDefault(_closure);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _closure2.default,
  bindings: {
    adverseEvent: '<',
    statuses: '<',
    locked: '<',
    onClosed: '&'
  },
  controller: function () {
    function ClosureComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, ClosureComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(ClosureComponent, [{
      key: 'onSubmit',
      value: function onSubmit() {
        this.onClosed(this.EventEmitter({
          adverseEvent: this.adverseEvent
        }));
      }
    }]);

    return ClosureComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/adverse-event/closure/closure.component.js